module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_ir-4749671e1d23a3d3bca3b1dde55f91df.jpg";